export default class Cookie {
  constructor(selector) {
    this.banner = document.querySelector(selector);
    if (this.banner) {
      this.banner.classList.add('show');
    }
  }
}
